/**
 * PUT raw file bytes to an S3 presigned URL. The Content-Type sent here MUST
 * match the one the URL was signed with (returned in uploadUrl.headers), or
 * S3 rejects with SignatureDoesNotMatch — so echo the signed headers verbatim.
 */
export async function putFileToPresignedUrl(
  uploadUrl: { url: string; method?: string; headers?: unknown },
  file: File,
): Promise<void> {
  const headers = (uploadUrl.headers && typeof uploadUrl.headers === 'object'
    ? (uploadUrl.headers as Record<string, string>)
    : {}) as Record<string, string>;
  const resp = await fetch(uploadUrl.url, {
    method: uploadUrl.method || 'PUT',
    headers,
    body: file,
  });
  if (!resp.ok) {
    throw new Error(`File upload to storage failed (${resp.status})`);
  }
}
